// Keep external video support limited to the two providers used by the articles.
// Article HTML stays sanitized; an ordinary source link works without JavaScript.
export function articleVideoEmbed(rawUrl) {
  let url
  try { url = new URL(rawUrl) } catch { return null }
  if (url.protocol !== "https:" || url.username || url.password || url.port) return null

  if (["www.youtube.com", "youtube.com"].includes(url.hostname) && url.pathname === "/watch") {
    const id = url.searchParams.get("v")
    return /^[A-Za-z0-9_-]{11}$/.test(id || "") ? `https://www.youtube-nocookie.com/embed/${id}` : null
  }

  if (["www.facebook.com", "web.facebook.com", "facebook.com"].includes(url.hostname) &&
      /^\/(?:reel\/\d+|[A-Za-z0-9._-]+\/videos\/\d+)\/?$/.test(url.pathname)) {
    const source = `https://www.facebook.com${url.pathname}`
    return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(source)}&show_text=false&width=560`
  }
  return null
}

// Facebook post embeds are rebuilt from a narrowly validated public post URL.
// Raw WordPress iframes and their arbitrary attributes never enter article HTML.
export function articleSocialEmbed(rawUrl) {
  let url
  try { url = new URL(rawUrl) } catch { return null }
  if (url.protocol !== "https:" || url.username || url.password || url.port) return null
  if (!["www.facebook.com", "web.facebook.com", "facebook.com"].includes(url.hostname)) return null
  if (!/^\/[A-Za-z0-9._-]+\/posts\/(?:\d+|pfbid[A-Za-z0-9]+)\/?$/.test(url.pathname)) return null
  const source = `https://www.facebook.com${url.pathname}`
  return `https://www.facebook.com/plugins/post.php?href=${encodeURIComponent(source)}&show_text=true&width=560`
}
